import { EntityListView } from '../components/EntityListView';

export function UnidadesView({ unidades, empresas, loading, onAdd, onEdit, onDelete }) {
  return (
    <EntityListView
      title="Unidades de negócio"
      subtitle="Sub-empresas dentro de uma empresa (ex: CORBAN, CRO)"
      items={unidades}
      loading={loading}
      addLabel="Nova unidade"
      emptyText="Nenhuma unidade cadastrada"
      onAdd={onAdd}
      onEdit={onEdit}
      onDelete={onDelete}
      columns={[
        { key: 'nome', label: 'Nome', render: (u) => (
          <div style={{ fontWeight: 600 }}>{u.nome}</div>
        )},
        { key: 'empresa_id', label: 'Empresa (mãe)', render: (u) => {
          const e = empresas.find(x => x.id === u.empresa_id);
          return e ? (
            <span className="chip" style={{
              background: 'var(--primary-soft)',
              color: 'var(--primary)',
              borderColor: 'var(--primary-line)',
            }}>{e.nome_fantasia || e.razao_social}</span>
          ) : '—';
        }},
        { key: 'logo_url', label: 'Logo', render: (u) =>
          u.logo_url
            ? <span style={{ fontSize: 12, color: 'var(--primary)' }}>✓ cadastrada</span>
            : <span style={{ fontSize: 12, color: 'var(--muted-2)' }}>—</span>
        },
      ]}
    />
  );
}
